import { request } from '@/util/http'

export const getIntroduction = (wxUserId) => {
  return request({
    url: `/health/doctor/introduction/${wxUserId}`,
    method: 'get'
  })
}

export const getPage = (param) => {
  return request({
    url: `/health/doctor/introduction/page`,
    method: 'post',
    data: param
  })
}

export const saveIntroduction = (param) => {
  return request({
    url: `/health/doctor/introduction`,
    method: 'post',
    data: param
  })
}

export const removeIntroduction = (wxUserId) => {
  return request({
    url: `/health/doctor/introduction/${wxUserId}`,
    method: 'delete'
  })
}
